/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

/**
 * QR code types handled by the platform, mirrors the backend QRCodeType enum.
 */
export const QR_CODE_TYPE = {
    MATERIAL_REQUEST: 9,
};

/**
 * Scanner states.
 *
 * IDLE: The camera is off, waiting for the user to start the scan.
 * SCANNING: The camera is on and looking for a QR code.
 * RESOLVING: A QR code was read and its identifier is being decrypted.
 * BLOCKED: The camera could not be started, usually a denied permission.
 */
export const SCANNER_STATUS = {
    IDLE: 'idle',
    SCANNING: 'scanning',
    RESOLVING: 'resolving',
    BLOCKED: 'blocked',
};

/**
 * Status label and status chip style for every scanner state.
 */
export const SCANNER_STATUS_ACTIONS = {
    [SCANNER_STATUS.IDLE]: {
        label: 'scanner_idle',
        tone: 'neutral',
        loading: false,
    },

    [SCANNER_STATUS.SCANNING]: {
        label: 'scanner_scanning',
        tone: 'active',
        loading: false,
    },

    [SCANNER_STATUS.RESOLVING]: {
        label: 'scanner_resolving',
        tone: 'active',
        loading: true,
    },

    [SCANNER_STATUS.BLOCKED]: {
        label: 'scanner_blocked',
        tone: 'error',
        loading: false,
    },
};

/**
 * Identifier of the html element where the camera preview is mounted.
 */
export const SCANNER_REGION_ID = 'material-request-scanner-region';

/**
 * Camera configuration used by Html5Qrcode.
 *
 * No 'qrbox' is set on purpose: with a scan box the library crops the frame
 * using the size the preview had when the camera started, and any later layout
 * change leaves the crop out of place, so the whole frame is scanned instead.
 * The native barcode detector is used when the browser supports it because it
 * reads dense codes faster.
 */
export const SCANNER_CONFIG = {
    fps: 10,
    videoConstraints: {
        facingMode: 'environment',
        width: { ideal: 1280 },
        height: { ideal: 720 },
    },
    experimentalFeatures: {
        useBarCodeDetectorIfSupported: true,
    },
};

/**
 * Matches the material request identifier returned by the decrypt service.
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
